/**
 * @file why hatu
 * @author 陈恩浩
 */

import React, { Component } from "react";
import { withTranslation } from "react-i18next";

import "./index.scss";

@withTranslation()
class WhyHatu extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    let introlist = [
      {
        title: "个性化定制",
        intro1: "根据孩子的年龄、水平、学习目的",
        intro2: "匹配最适合的中文课程",
      },
      {
        title: "多班型可选",
        intro1: "1对1，1对多",
        intro2: "多种班型多种选择",
      },
      {
        title: "趣味互动教学",
        intro1: "多感官课堂活动设计",
        intro2: "游戏化教学，孩子喜欢",
      },
      {
        title: "固定老师授课",
        intro1: "是老师更像是朋友",
        intro2: "陪伴孩子一路成长",
      },
      {
        title: "课程丰富多样",
        intro1: "三大系列课程，体系完整",
        intro2: "有针对性的选择",
      },
      {
        title: "全程跟踪服务",
        intro1: "专业的课程顾问老师",
        intro2: "全程跟踪服务",
      },
    ];
    return (
      <div className="home-whyHatu">
        <div className="inner">
          <div className="inner-title">学中文 为什么选哈兔</div>
          <ul className="intro">
            {introlist.map((item, index) => (
              <li key={"intro-" + index}>
                <div className="img"></div>
                <div className="title">{item.title}</div>
                <div className="intro">
                  <p>{item.intro1}</p>
                  <p>{item.intro2}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

export default WhyHatu;
